export const SortDirection = Object.freeze({
    ASC: 'asc',
    DESC: 'desc',
} as const);

export const descendingIfTrue = (descending: boolean) =>
    descending ? SortDirection.DESC : SortDirection.ASC;
